export default "__VITE_ASSET__62b9ac9b__"